// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getDatabase} from "firebase/database"

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAPHuC-aFaDX047kFTFzVvTIMxYZsUu-10",
  authDomain: "tsofie-app-e1ff2.firebaseapp.com",
  databaseURL: "https://tsofie-app-e1ff2-default-rtdb.firebaseio.com",
  projectId: "tsofie-app-e1ff2",
  storageBucket: "tsofie-app-e1ff2.firebasestorage.app",
  messagingSenderId: "926254295793",
  appId: "1:926254295793:web:6db3cf97f5d45c24155750",
  measurementId: "G-2VW51ZXN85"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getDatabase(app);

export default app